// extracted by mini-css-extract-plugin
export var copy = "giftCard-module--copy--3410f";
export var form = "giftCard-module--form--327e5";
export var gcwrap = "giftCard-module--gcwrap--41a63";
export var inputError = "giftCard-module--input-error--89c71";
export var loglink = "giftCard-module--loglink--bcca3";
export var logwarn = "giftCard-module--logwarn--b6c4e";
export var submitWr = "giftCard-module--submitWr--70a71";
export var title = "giftCard-module--title--b8727";